"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_style_proptype_1 = __importDefault(require("react-style-proptype"));
const emotion_1 = require("emotion");
const utils_1 = require("./utils");
const isTextTruthy = val => val !== undefined && val !== null && val.toString() !== '';
const TextField = react_1.default.forwardRef((_a, ref) => {
    var { autoFocus, bsStyle, className, disabled, helpText, id, inputStyle, label, name, onBlur, onChange, onClick, onFocus, onKeyDown, placeholder, required, rightAddon, status, style, type, value, pattern } = _a, rest = __rest(_a, ["autoFocus", "bsStyle", "className", "disabled", "helpText", "id", "inputStyle", "label", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "placeholder", "required", "rightAddon", "status", "style", "type", "value", "pattern"]);
    const [float, setFloat] = react_1.useState(isTextTruthy(value));
    const uniqueId = utils_1.useMemoizedId({ label: `${name}-${placeholder}-${label}` });
    react_1.useEffect(() => {
        setFloat(isTextTruthy(value));
    }, [setFloat, value]);
    const handleBlur = e => {
        setFloat(isTextTruthy(value));
        onBlur && onBlur(e);
    };
    const handleFocus = e => {
        setFloat(true);
        onFocus && onFocus(e);
    };
    const handleChange = e => {
        const isValid = !pattern || !!e.target.value.match(new RegExp(`^${pattern}$`));
        onChange && onChange(Object.assign(Object.assign({}, e), { isValid }));
    };
    const inputId = id || uniqueId;
    const isTextArea = type === 'textarea';
    const wrapperClassNames = emotion_1.cx('form-group', className, { 'form-group-active': label && float, [`has-${status || bsStyle}`]: status || bsStyle, required, disabled });
    const inputProps = Object.assign(Object.assign({}, rest), { autoFocus, className: 'form-control', disabled, id: inputId, name, onBlur: handleBlur, onChange: handleChange, onClick, onFocus: handleFocus, onKeyDown,
        placeholder,
        ref,
        required, style: inputStyle, value,
        pattern });
    if (!isTextArea) {
        inputProps.type = type;
    }
    const inputElement = isTextArea ? (react_1.default.createElement("textarea", Object.assign({}, inputProps))) : (react_1.default.createElement("input", Object.assign({}, inputProps)));
    const labelElement = label ? (react_1.default.createElement("label", { className: emotion_1.cx('control-label', { 'textarea-label': isTextArea }), htmlFor: inputId, title: label }, label)) : null;
    return (react_1.default.createElement("div", { className: wrapperClassNames, style: style },
        react_1.default.createElement("div", { className: "input-group", style: { width: '100%', zIndex: 0 } },
            inputElement,
            labelElement,
            rightAddon && react_1.default.createElement("span", { className: "input-group-btn" }, rightAddon)),
        helpText ? react_1.default.createElement("small", { className: "help-block" }, helpText) : null));
});
TextField.displayName = 'TextField';
TextField.defaultProps = {
    autoFocus: false,
    className: '',
    disabled: false,
    required: false,
    type: 'text',
    value: '',
};
TextField.propTypes = {
    name: prop_types_1.default.string,
    type: prop_types_1.default.oneOf(['text', 'number', 'password', 'url', 'search', 'email', 'tel', 'textarea']),
    value: prop_types_1.default.oneOfType([prop_types_1.default.string, prop_types_1.default.number]),
    label: prop_types_1.default.node,
    placeholder: prop_types_1.default.string,
    helpText: prop_types_1.default.node,
    id: prop_types_1.default.string,
    required: prop_types_1.default.bool,
    disabled: prop_types_1.default.bool,
    autoFocus: prop_types_1.default.bool,
    status: prop_types_1.default.oneOf(['success', 'warning', 'error', '']),
    className: prop_types_1.default.string,
    onChange: prop_types_1.default.func,
    onClick: prop_types_1.default.func,
    onKeyDown: prop_types_1.default.func,
    onBlur: prop_types_1.default.func,
    onFocus: prop_types_1.default.func,
    style: react_style_proptype_1.default,
    inputStyle: react_style_proptype_1.default,
    rightAddon: prop_types_1.default.element,
    pattern: prop_types_1.default.string,
    bsStyle: utils_1.deprecatedProp(prop_types_1.default.oneOf(['success', 'warning', 'error', '']), 'Use `status` instead.'),
};
exports.default = TextField;
